import { Component, OnInit } from '@angular/core';
import { MxSlider } from '../mx-slider.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSliderChange } from '@angular/material/slider';
import { Location } from '@angular/common';
import { MxSliderConfig } from '../mx-slider.model';
import { Input } from '@angular/core';


interface FX { value: string, display: string }
interface Orientacion { value: string, display: string }
@Component({
  selector: 'mx-slider-config',
  templateUrl: './mx-slider-config.component.html',
  styleUrls: ['./mx-slider-config.component.scss']
})
export class MxSliderConfigComponent implements OnInit {

  @Input() collection: string = 'marxa-devs'
  SliderConfig: MxSliderConfig
  timing: number
  efect: string
  maxWidth: number
  slideHeight
  efects: FX[] = [
    { value: 'ease-in', display: 'Entrada suave' },
    { value: 'ease-out', display: 'Salida suave' },
    { value: 'ease-in-out', display: 'Entrada y salida suave' }
  ]
  orientaciones: Orientacion[] = [
    { value: 'ltr', display: 'Izquierda a derecha' },
    { value: 'rtl', display: 'Derecha a izquierda' },
  ]

  constructor (
    private _slider: MxSlider,
    public location: Location
  ) {
    this.SliderConfig = this._slider.sliderConfig
    this.timing = 250
    this.efect = 'ease-in'
    this.maxWidth = 100
    this.slideHeight = 100
  }

  ngOnInit(): void {
    this._slider.loadConfiguration().subscribe( config => {
      if ( config ) {
        this.SliderConfig = config
        this.timing = +config.timings.split('ms')[0]
        this.efect = config.timings.split(' ')[1]
        this.maxWidth = config.maxWidth != 'auto' ?
          +config.maxWidth.split('%')[0] : 100
        this.slideHeight = config.slideHeight ?
          +config.slideHeight.split('px')[0] : 100
      }
    })
  }

  formatLabel( value: number ) {
    if ( value >= 1 ) {
      return Math.round( value / 1 ) + '%';
    } return value;
  }



  onMaxwidth( event: MatSlideToggleChange ) {
    console.log(event.checked);
    this.SliderConfig.maxWidth = event.checked ? 'auto' : ''
    console.log( this.SliderConfig.maxWidth);
  }





  onSubmit() {
    this.SliderConfig.timings = `${ this.timing }ms ${ this.efect }`
    this.SliderConfig.maxWidth = this.SliderConfig.maxWidth == 'auto' ?
      'auto' : `${ this.maxWidth }%`;
    if ( !this.SliderConfig.maintainAspectRatio ) {
      this.SliderConfig.slideHeight = this.slideHeight + 'px'
    } else {
      delete this.SliderConfig.slideHeight
    }


    this._slider.setSliderConfiguration(this.SliderConfig, this.collection)
  }

}
